<template>
    <iframe src="http://phems.proheng.net/grapheditor/" class="grapheditor"></iframe>
</template>

<script>
export default {
    name:"grapheditor"
}
</script>

<style lang="scss">
.grapheditor{
    width:100%;
    height: 100%;
    border:none;
    padding: 0;
    margin:0;
}
.el-main.grapheditor-wrap{
    overflow: hidden;
}
</style>